import { CopyOutlined } from '@ant-design/icons'
import { QRCodeSVG } from 'qrcode.react'
import { Button } from './Button'
import { OrderLayout } from './OrderLayout'
import { ProductInstruction } from './ProductInstruction'
import { ShopFollow } from './ShopFollow'
import { useMessage } from '../hooks/message.hook.js'

const ESIMValue = ({ label, value }) => {
  const message = useMessage()
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      message('Код скопирован в буфер обмена!')
    } catch {
      message('Не удалось скопировать код. Выделите его вручную.')
    }
  }
  if (!value) return null
  return <div>
    <div className='order-value-label'>{label}</div>
    <div className='order-code'><code>{value}</code>
      <button type='button' className='order-copy' aria-label={`Скопировать ${label}`} onClick={copy}><CopyOutlined /></button>
    </div>
  </div>
}

export const ESIMOrder = ({ orders, messageContent }) => {
  if (!orders) return messageContent
  const iosInstallLink = orders.appleUniversalLink || orders.iosInstallUrl
  const androidInstallLink = orders.androidUniversalLink || orders.androidInstallUrl
  return <OrderLayout orders={orders} kind='eSIM' status='eSIM получена' after={<>
    <ProductInstruction title='Как установить eSIM' hint='Установка и настройка мобильного интернета — в инструкции.' html={orders.issue_instruction} />
    <ShopFollow />
  </>}>
    <h2 className='order-result-title'>QR-код для установки eSIM</h2>
    <div className='order-esim'>
      {orders.qrCodeText && <div className='order-esim__qr' aria-label='QR-код для установки eSIM'>
        <QRCodeSVG value={orders.qrCodeText} size={240} level='M' marginSize={4} />
      </div>}
      <div>
        <p className='order-note'>Отсканируйте QR-код камерой телефона. Если страница открыта на нём же — используйте установку или ручные данные.</p>
        <div className='order-install-actions'>
          {iosInstallLink && <Button type='primary' color='purple' size='md' onClick={() => window.open(iosInstallLink, '_blank')}>Установить на iPhone</Button>}
          {androidInstallLink && <Button type='primary' color='purple' size='md' onClick={() => window.open(androidInstallLink, '_blank')}>Установить на Android</Button>}
        </div>
      </div>
    </div>
    <details className='order-esim__manual'>
      <summary>Данные для ручной установки</summary>
      <div className='order-esim__values'>
        <ESIMValue label='Адрес SM-DP+' value={orders.smdpAddress} />
        <ESIMValue label='Код активации' value={orders.activationCode} />
        <ESIMValue label='Matching ID' value={orders.matchingId} />
        <ESIMValue label='ICCID' value={orders.iccid} />
        <ESIMValue label='Код QR (LPA)' value={orders.qrCodeText} />
      </div>
    </details>
  </OrderLayout>
}
